"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSavedSearchesToFilterItems = exports.formatSearchFilter = exports.formatSearchSubject = void 0;
const advancedSearch_1 = require("../advancedSearch");
const constants_1 = require("../../../constants");
const formatSearchSubject = (label, [first, ...rest]) => `${label} (${rest.length ? `${[first, ...rest].length} subjects` : first?.label})`;
exports.formatSearchSubject = formatSearchSubject;
const formatSearchFilter = (filter, config) => {
    const { category, path, subjects, value } = filter;
    // TODO: this can fail, what should we do if there is no matching category/path here?
    const { label, allowedSubjects } = config[category].filters[path];
    const mapping = (allowedSubjects?.subjects || []).reduce((map, subject) => ({ ...map, [subject.value]: subject }), {});
    const filteredSubjects = subjects?.map((subject) => mapping[subject]).filter((v) => !!v) || [];
    return {
        ...filter,
        label: filteredSubjects.length
            ? (0, exports.formatSearchSubject)(label, filteredSubjects)
            : label,
        displayedValue: (0, advancedSearch_1.getDisplayedFilterValue)(value),
    };
};
exports.formatSearchFilter = formatSearchFilter;
const mapSavedSearchesToFilterItems = (savedSearches, type, config) => [
    {
        id: "episource",
        sectionId: constants_1.SAVED_SEARCHES_SECTION_ID,
        type: constants_1.AdvancedSearchFilterOptionType.SelectableList,
        name: "Standard (Episource)",
        items: savedSearches
            .filter(({ objectType, scope }) => objectType === type && scope === constants_1.Scope.Episource)
            .map((filteredSearch) => ({
            ...filteredSearch,
            type: constants_1.AdvancedSearchFilterOptionType.SavedSearch,
            viewableByAll: true,
            filters: filteredSearch.filters.map((filter) => (0, exports.formatSearchFilter)(filter, config)),
        })),
    },
    {
        id: "userSaved",
        sectionId: constants_1.SAVED_SEARCHES_SECTION_ID,
        type: constants_1.AdvancedSearchFilterOptionType.SelectableList,
        name: "User Saved",
        items: savedSearches
            .filter(({ objectType, scope }) => objectType === type &&
            (scope === constants_1.Scope.Personal || scope === constants_1.Scope.Global))
            .map((filteredSearch) => ({
            ...filteredSearch,
            type: constants_1.AdvancedSearchFilterOptionType.SavedSearch,
            viewableByAll: filteredSearch.scope === constants_1.Scope.Global,
            filters: filteredSearch.filters.map((filter) => (0, exports.formatSearchFilter)(filter, config)),
        })),
    },
];
exports.mapSavedSearchesToFilterItems = mapSavedSearchesToFilterItems;
